module.exports = __webpack_public_path__ + "img/porto-1.6e6c5f60.png";